import React from 'react';
import Events from '../hooks/events';
import NotificationCardItem from './NotificationCardItem';

const NotificationCardItems = ({
  category,
  code,
  event,
  items,
}) => {
  const showNotification = Events.useShowNotification(category, { code });
  return (
    items.map((item, index) => (
      <NotificationCardItem
        category={category}
        code={code}
        event={event}
        key={`notifications_list_item_${item.code}`}
        notification={item}
        showNotification={showNotification}
        upward={index > 4}
      />
    ))
  );
};

export default NotificationCardItems;
